import React, { useEffect, useState } from "react";

import $ from "jquery";
import { Image, Dimmer, Loader, Icon } from 'semantic-ui-react';
import { imagesJSON } from "../../background/Background";

import ButtonPushNewImage from "./ButtonPushNewImage";

import heart_solid from "../../../images/heart_solid.png";
import heart_regular from "../../../images/heart_regular.png";

export let actualFolder = { folders: [], files: [] }

function ImageSelector(props) {
    const [defaultImageName, setDefaultImageName] = useState((props.imageName) ? props.imageName : (localStorage.getItem("default-image-name")) ? localStorage.getItem("default-image-name") : "bg-01");
    const [htmlBacgroundImages, setHtmlBackroundImages] = useState(<Dimmer active><Loader indeterminate>{(props.lang === "es") ? "Preparando los archivos" : "Preparing files"}</Loader></Dimmer>);
    const [images, setImages] = useState((localStorage.getItem("images")) ? JSON.parse(localStorage.getItem("images")) : imagesJSON);

    function getIndexOfChild(icon) {
        const parent = $(icon).closest("div#image-selector");
        const child = $(icon).parent().parent();
        return parent.children().toArray().indexOf(child[0]);
    }

    function handleOnPushImage(images) {
        setImages(images);
    }

    function changeBackgroundImage(target, img) {
        $("#root").css("background-image", `url(${img.full})`);
        $(".img-background-border.bg-img-border-active").removeClass("bg-img-border-active");
        $(".img-background.bg-img-active").removeClass("bg-img-active");

        $(target).parent("div.img-background-border").addClass("bg-img-border-active");
        $(target).addClass("bg-img-active");

        localStorage.setItem("default-image", img.full);
        localStorage.setItem("default-image-name", img.name);
    }

    function changeFavStatus(e, images) {
        const index = getIndexOfChild(e.target);
        const imageType = $(e.target).attr("type");
        $(e.target).prop("src", (imageType === "solid") ? heart_regular : heart_solid);
        $(e.target).attr("type", (imageType === "solid") ? "regular" : "solid");
        images[index].fav = !images[index].fav;
        localStorage.setItem("images", JSON.stringify(images));
    }

    function removeBackgroundImage(e, image) {
        e.stopPropagation();
        let imgs = images;
        for (let i = 0; i < imgs.length; i++) {
            if (imgs[i].name === image.name) {
                imgs.splice(i, 1);
                break;
            }
        }
        for (let i = 0; i < imgs.length; i++) {
            const num = i + 1;
            if (num < 10) {
                imgs[i].name = "bg-0" + num;
            } else {
                imgs[i].name = "bg-" + num;
            }
        }
        if (localStorage.getItem("default-image-name") === image.name) {
            changeBackgroundImage($("img[title='bg-01']")[0], imgs[0]);
        }
        localStorage.setItem("images", JSON.stringify(imgs));
        setImages((localStorage.getItem("images")) ? JSON.parse(localStorage.getItem("images")) : imagesJSON);
    }

    useEffect(() => {
        setDefaultImageName((props.imageName) ? props.imageName : (localStorage.getItem("default-image-name")) ? localStorage.getItem("default-image-name") : "bg-01");
        setImages((props.images) ? props.images : (localStorage.getItem("images")) ? JSON.parse(localStorage.getItem("images")) : imagesJSON);

        if (props.defaultImage) {
            const image = props.defaultImage;
            $("#root").css("background-image", `url(${image})`);
        }
    }, [props])

    useEffect(() => {
        setHtmlBackroundImages(images.map((img, i) => {
            let classBox = (defaultImageName === img.name) ? "img-background-border bg-img-border-active" : "img-background-border";
            let classImg = (defaultImageName === img.name) ? "img-background bg-img-active" : "img-background";
            let typeFav = (img.fav) ? 'solid' : 'regular';
            return (
                <div key={i}>
                    <div className={classBox} onClick={(e) => changeBackgroundImage(e.target, img)}>
                        <Image src={img.full} className={classImg} alt={img.name} title={img.name} />
                        {(img.full.includes(";base64,")) ? <div title="Remove background" onClick={(e) => removeBackgroundImage(e, img)} className="remove-bg"><Icon name="trash" /></div> : null}
                    </div>
                    <div className="box-favorite" onClick={(e) => changeFavStatus(e, images)}>
                        <Image src={(typeFav === "solid") ? heart_solid : heart_regular} alt="like" type={typeFav} style={{ width: "20px" }} />
                    </div>
                </div>
            )
        }));
    }, [defaultImageName, images])

    return (
        <div id="image-selector">
            {htmlBacgroundImages}
            <ButtonPushNewImage lang={props.lang} onPushImage={handleOnPushImage} />
        </div>
    )
}

export default ImageSelector